import { AxiosClient } from "../../../configs/axios/axios";
import { LOCAL_STORAGE_KEY } from "../../../constants";
import Storage from "../../../utils/storage";

const apiVersion = process.env.REACT_APP_VERSION;

const DivisionsApi = {
  getListDivisionTiersRewards: async (params) => {
    const result = await new AxiosClient().get(`api/v1/division-tiers/rewards`, {
      headers: {
        "x-access-token": Storage.get(LOCAL_STORAGE_KEY.ACCESS_TOKEN),
        "Content-Type": "application/json",
      },
      params,
    });

    return result;
  },

  getDivisionTiers: async (params) => {
    const result = await new AxiosClient().get(
      `${apiVersion}/division-tiers`,
      {
        headers: {
          "x-access-token": Storage.get(LOCAL_STORAGE_KEY.ACCESS_TOKEN),
          "Content-Type": "application/json",
        },
        params,
      }
    );

    return result;
  },

  getDivisionTiersMe: async (params) => {
    const result = await new AxiosClient().get(
      `${apiVersion}/division-tiers/me`,
      {
        headers: {
          "x-access-token": Storage.get(LOCAL_STORAGE_KEY.ACCESS_TOKEN),
          "Content-Type": "application/json",
        },
        params,
      }
    );

    return result;
  },

  nftReward: async (params) => {
    const result = await new AxiosClient().post(
      "api/v1/division-tiers/nft-reward",
      params,
      {
        headers: {
          "x-access-token": Storage.get(LOCAL_STORAGE_KEY.ACCESS_TOKEN),
          "Content-Type": "application/json",
        },
      }
    );

    return result;
  },

  getDivisionTiersHistory: async (params) => {
    const result = await new AxiosClient().get(
      `${apiVersion}/division-tiers/rewards/history`,
      {
        headers: {
          "x-access-token": Storage.get(LOCAL_STORAGE_KEY.ACCESS_TOKEN),
          "Content-Type": "application/json",
        },
        params,
      }
    );

    return result;
  },
};

export default DivisionsApi;
